// extracted by mini-css-extract-plugin
export default {"map_container":"contact_map_container__cLbga","two_column_text":"contact_two_column_text__IJHkA","text":"contact_text__S6gG6","link":"contact_link__Jpgkx"};